<template>
  <div class="home-service-container">
    <!-- <div class="container text-center color-ccc fs-30 empty-tip ">
        {{ $t("public.nomore") }}
      </div> -->

    <!-- <div class="service-item" v-for="(item,index) in contactList" :key="index">
      <div class="item-title media_font_size_50">{{item.title}}</div>
      <span class="media_font_size_50">地址/address：{{item.address}}</span>
      <span class="media_font_size_50">联系电话/phone：{{item.contact}}</span>
      <span class="media_font_size_50">传真/fax：{{item.fax}}</span>
      <span class="media_font_size_50">联系人/name：{{item.name}}</span>
      <span class="media_font_size_50">电子邮箱/email：{{item.email}}</span>
      <span v-if="item.website" class="media_font_size_50">网址：{{item.website}}</span>
    </div> -->
    <div class="service-item">
      <div class="item-title media_font_size_50">{{$t("service.company2")}}</div>
      <!-- <span class="media_font_size_50">{{$t("service.address")+$t("service.company1")}}</span> -->
      <span class="media_font_size_50">{{$t("service.contactname")+$t("service.name21")+' / '+$t("service.phone21")+' / '+$t("service.email21")}}</span>
      <span class="media_font_size_50 text_indet">{{$t("service.name22")+' / '+$t("service.phone22")+' / '+$t("service.email22")}}</span>
      <span class="media_font_size_50 text_indet">{{$t("service.name23")+' / '+$t("service.phone23")+' / '+$t("service.email23")}}</span>
      <!-- <span class="media_font_size_50">{{$t("service.contactname")+item.name}}</span> -->
      <!-- <span class="media_font_size_50">电子邮箱/email：{{item.email}}</span> -->
      <!-- <span v-if="item.website" class="media_font_size_50">网址：{{item.website}}</span> -->
    </div>
    <div class="service-item">
      <div class="item-title media_font_size_50">{{$t("service.company1")}}</div>
      <!-- <span class="media_font_size_50">{{$t("service.address")+$t("service.company1")}}</span> -->
      <span class="media_font_size_50">{{$t("service.contactname")+$t("service.name11")+' / '+$t("service.phone11")+' / '+$t("service.email11")}}</span>
      <span class="media_font_size_50 text_indet">{{$t("service.name12")+' / '+$t("service.phone12")+' / '+$t("service.email12")}}</span>
      <span>
        
      </span>
      <!-- <span class="media_font_size_50">{{$t("service.contactname")+item.name}}</span> -->
      <!-- <span class="media_font_size_50">电子邮箱/email：{{item.email}}</span> -->
      <!-- <span v-if="item.website" class="media_font_size_50">网址：{{item.website}}</span> -->
    </div>
     
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactList: [
        // {
        //   title: "主场承建商:广州亚海展览有限公司",
        //   address: "广州市海珠区江海大道3号凯荣都国际大酒店14楼1401-1408室",
        //   contact: "020-89040715/17/19",
        //   fax: "020-89040716",
        //   name: "张玮",
        //   email: "nicole_zhang@aseaexpo.com"
        // },
        // {
        //   title: "主场运输商:运展环球物流(北京)有限公司广州公司",
        //   address: "广州市越秀区环市东路338号花园酒店花园大厦633房",
        //   contact: "020-8365 2984",
        //   fax: "020-8265 2654",
        //   name: "刘家俊",
        //   email: "Marco.liu@expotransworld.com"
        // },
        // {
        //   title: "现场广告代理商:广州星亚广告有限公司",
        //   address: "广州市海珠区广州大道南863号银业国际B座204",
        //   contact: "020-89040246、13928876202",
        //   fax: "+86 20 8904 0246",
        //   name: "刘鹏",
        //   email: "roc_liu@asias-ad.com",
        //   website: "www.asias-ad.com"
        // }
      ]
    };
  }
};
</script>

<style lang="scss">
.home-service-container {
  width: 100%;
  display: flex;
  margin-bottom: 50px;
  justify-content: space-between;
  .service-item {
    display: flex;
    // flex: 1;
    flex-direction: column;
    font-size: 14px;
    margin-right: 10px;
    line-height: 40px;
    .text_indet{
      text-indent: 60px;
    }
    .item-title {
      color: #42abff;
      border-left: 14px solid #42abff;
      padding-left: 10px;
      font-weight: bold;
      font-size:14px;
    }
    > span {
    }
  }
}

@media screen and (max-width: 1000px) {
  .home-service-container {
      flex-direction: column;
    .service-item {
      line-height: 120px;
      margin-bottom: 100px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// homeService.vue?3e6be73e